import hometemplate from './home.tpl.html';
import {
  getReviewingQuestionnaires,
  getReviewingQuestionnairesTotal,
  getLoading as getQuestionnairesLoading,
} from '../../reducers/questionnaires';

import {
  getReviewingUsersTotal,
  getReviewingUsers,
} from '../../reducers/users';

import utils from '../../services/utils';

export class Home {
  constructor($scope, $ngRedux, actionsFactory, $translate) {
    Object.assign(this, {
      $scope,
      $ngRedux,
      actionsFactory,
      $translate,
    });
    const unsubscribe = $ngRedux.connect(this.mapStateToThis, actionsFactory)(this);
    $scope.$on('$destroy', unsubscribe);
  }

  $onInit() {
    this.page = 1;
    this.limit = 10;
    this.showConfirmationModal = false;

    this.searchColumns = [
      {
        type: 'text',
        id: 'company_name',
        fields: ['company.name'],
        labelKey: 'TABLE_HEADER_COMPANY',
        sortable: true,
        width: '30%',
      },
      {
        id: 'last_updated_at',
        type: 'datetime',
        labelKey: 'TABLE_HEADER_LAST_UPDATED_AT',
        fields: ['lastUpdatedAt'],
        width: '20%',
      },
      {
        id: 'quick_report_score',
        type: 'text',
        labelKey: 'TABLE_HEADER_QUICK_SCORE',
        fields: ['quickReportScore'],
        width: '10%',
      },
      {
        id: 'base_score',
        type: 'text',
        labelKey: 'TABLE_HEADER_BASE_SCORE',
        fields: ['baseScore'],
        width: '10%',
      },
      {
        id: 'nando_score',
        type: 'text',
        labelKey: 'TABLE_HEADER_NANDO_SCORE',
        fields: ['nandoScore'],
        width: '20%',
      },
      {
        id: 'nando_plus_score',
        type: 'text',
        labelKey: 'TABLE_HEADER_NANDO_PLUS_SCORE',
        fields: ['nandoPlusScore'],
        width: '20%',
      },
    ];
    this.searchParams = [
      {
        searchKey: 'GENERIC_COMPANY',
        type: 'input',
        input: '',
        id: 'company_name',
      },
    ];

    if (this.auth.user.type === 'editor') {
      this.reqReviewing();
      this.reqReviewingQuestionnairesStart({
        page: this.page,
        limit: this.limit,
      });
    }
  }

  /* eslint-disable */
  mapStateToThis(state) {
    return {
      auth: state.authentication,
      reviewingUsersTotal: getReviewingUsersTotal(state),
      reviewingUsers: getReviewingUsers(state),
      questionnaires: getReviewingQuestionnaires(state),
      questionnairesNeedingReviewTotal: getReviewingQuestionnairesTotal(state),
      loading: getQuestionnairesLoading(state),
    };
  }
  /* eslint-enable */

  getAccountTypeDescription(type) {
    return this.$translate.instant(`ACCOUNT_TYPE_${type && type.toUpperCase()}`);
  }

  approveQuestionnaire(id) {
    this.approveQuestionnaireStart(id);
    this.hideConfirmationModal();
    this.reqReviewingQuestionnairesStart({
      page: this.page,
      limit: this.limit,
    });
  }

  checkQuestionnaire(questionnaireId, companyId) {
    this.goTo('authenticated.company.detail.questionnaire', { id: companyId, questionnaireId });
  }

  loadPrev() {
    this.page -= 1;
    this.reqReviewingQuestionnairesStart({
      page: this.page,
      limit: this.limit,
    });
  }

  loadNext() {
    this.page += 1;
    this.reqReviewingQuestionnairesStart({
      page: this.page,
      limit: this.limit,
    });
  }

  searchOrderedCompaniesOverview(paramList) {
    this.requestOrderedCompaniesOverviewStart(paramList);
  }

  goTo(state, params) {
    this.state(state, params);
  }

  showPrevIsVisible() {
    return this.page > 1;
  }

  showNextIsVisible() {
    return this.questionnairesNeedingReviewTotal > this.page * this.limit;
  }

  doShowConfirmationModal(questionnaireId) {
    this.showConfirmationModal = true;
    this.questionnaireId = questionnaireId;
  }

  hideConfirmationModal() {
    this.showConfirmationModal = false;
  }

  isLoggedInUserOfType(types) {
    return utils.isLoggedInUserOfType(this.auth.user.type, types);
  }
}

Home.$inject = [
  '$scope',
  '$ngRedux',
  'actionsFactory',
  '$translate',
];

export const home = {
  template: hometemplate,
  controller: Home,
};
